// extracted by mini-css-extract-plugin
export default {"section":"WhiteSection_section__pTMuU"};